import { getCookie, setCookie, deleteCookie } from "./utilities/cookies";
import { safeJsonParse } from "./utilities/safe-json-parse";
import jwt_decode from "jwt-decode"; 
import { redirectAfterLogin } from "./utilities/redirect-after-login";

const cookieCustomerId = 'foxy-customer-id';
const cookieCustomerEmail = 'foxy-customer-email';
const cookieSessionToken = 'foxy-session-token';

customElements.whenDefined('foxy-customer-portal').then(() => {
    const portals = [...document.getElementsByTagName('foxy-customer-portal')];
    portals.forEach(portal => {
        portal.addEventListener('signin', function () {
            setCustomerIdCookie();
            setCustomerEmailCookie();
            setSessionTokenCookie();
            redirectAfterLogin();
        });

        portal.addEventListener('signup', function () {
            setCustomerIdCookie();
            setCustomerEmailCookie();
            setSessionTokenCookie();
            redirectAfterLogin();
        });

        portal.addEventListener('signout', function () {
            deleteCookie(cookieCustomerId);
            deleteCookie(cookieSessionToken);
            deleteCookie(cookieCustomerEmail);
        });
    });
}); 


export const getFoxySession = () => {
    const foxySession = localStorage.getItem('session');

    const foxySessionStore = safeJsonParse(foxySession);

    if(!foxySessionStore || !foxySessionStore.hasOwnProperty('jwt')) {
        return;
    }

    return jwt_decode(foxySessionStore.jwt);
}


export const getCustomerId = () => {
    const foxySession = getFoxySession();
    
    if(!foxySession || !foxySession.customer_id) {
        return;
    }

    return foxySession.customer_id;
}

export const getCustomerEmail = () => {
    const foxySession = getFoxySession();
    
    if(!foxySession || !foxySession.customer_email) {
        return;
    }

    return foxySession.customer_email;
}

export const setCustomerEmailCookie = () => {
    const customerEmailCookie = getCookie(cookieCustomerEmail);
    const foxySession = localStorage.getItem('session');
    
    //if the cookie is already set, and the user is not logged in do nothing but remove the cookie
    if(customerEmailCookie === true) {
        if(!foxySession) {
            deleteCookie(cookieCustomerEmail);
        }
        return;
    }

    const customerEmail = getCustomerEmail();

    if(!customerEmail) {
        return;
    }

    return setCookie(cookieCustomerEmail, customerEmail, 1);

};

export const setCustomerIdCookie = () => {
    const customerCookie = getCookie(cookieCustomerId);
    const foxySession = localStorage.getItem('session');
    
    //if the cookie is already set, and the user is not logged in do nothing but remove the cookie
    if(customerCookie === true) {
        if(!foxySession) {
            deleteCookie(cookieCustomerId);
        }
        return;
    }

    const customerId = getCustomerId();

    if(!customerId) {
        return;
    }

    return setCookie(cookieCustomerId, customerId, 1);

};

export const setSessionTokenCookie = () => {
    const customerCookie = getCookie(cookieSessionToken);
    const foxySession = localStorage.getItem('session');
    
    //if the cookie is already set, and the user is not logged in do nothing but remove the cookie
    if(customerCookie === true) {
        if(!foxySession) {
            deleteCookie(cookieSessionToken);
        }
        return;
    }

    //to do - check the session is there, check its json, if not delete cookies
    const foxySessionStore = safeJsonParse(foxySession);

    if(!foxySessionStore || !foxySessionStore.hasOwnProperty('session_token')) {
        return;
    }
    return setCookie(cookieSessionToken, foxySessionStore.session_token, 1);

};